export const TRACE_INLINE_ROW_GAP = 1.5;
export const TRACE_INLINE_ROW_MIN_HEIGHT = '24px';
export const TRACE_INLINE_LABEL_COLOR = 'fg.muted' as const;
export const TRACE_INLINE_SUMMARY_COLOR = 'fg.subtle' as const;
export const TRACE_INLINE_SCROLL_MAX_HEIGHT = '240px';
